module.exports = __webpack_public_path__ + "static/media/avolant.ce50d79a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/aguacate/climasense/acaro_cafe_aguacate/avolant.png
// module id = 1072
// module chunks = 3